<template>
  <el-main class="contact">
    <ContentNav
      :bannerTextIMG="require('../assets/contact/bannerText.png')"
      :bannerimgIMG="Url.imgUrl + this.$store.state.NavList[5].banner"
    ></ContentNav>
    <div class="content">
      <div class="Item-from">
        <el-form>
          <el-row class="Item-flex">
            <el-col>
              <el-form-item>
                <el-input
                  class="item-input"
                  v-model="form.username"
                  placeholder="您的姓名"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="您的手机号码" v-model="form.phone">
                  <el-button @click="GetCode(form.phone)" slot="append">{{
                    isSendCode
                  }}</el-button>
                </el-input>
              </el-form-item>

              <el-form-item>
                <el-input
                  type="textarea"
                  placeholder="问题概述"
                  v-model="form.problemDes"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item>
                <el-select
                  v-model="form.advisoryType"
                  placeholder="咨询类别"
                  style="width: 100%"
                >
                  <el-option label="民事" value="38"></el-option>
                  <el-option label="刑事" value="39"></el-option>
                  <el-option label="行政" value="40"></el-option>
                  <el-option label="其他" value="41"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input
                  placeholder="您收到的验证码"
                  v-model="form.code"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-select
                  v-model="provinceId"
                  placeholder="请选择省份"
                  style="width: 50%"
                  @change="selectProvince"
                >
                  <el-option
                    v-for="item in provinceList"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item.regionId"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="cityId"
                  placeholder="请选择市区"
                  style="width: 50%"
                  @change="selectCity"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.regionId"
                    :label="item.regionName"
                    :value="item.regionId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  :style="disabled == true ? 'background:#888' : ''"
                  :disabled="disabled"
                  class="submit"
                  type="primary"
                  @click="onSubmit"
                  >发 送</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="map">
        <img src="../assets/contact/map.png" alt />
      </div>
    </div>
    <Icongroup></Icongroup>
  </el-main>
</template>

<script>
import ContentNav from "../components/ContentNav";
import Icongroup from "../components/Icon_group";

export default {
  components: {
    ContentNav,
    Icongroup,
  },
  metaInfo() {
    return {
      title: `联系我们-${this.SystemOption.seoTitle ?? ""}`,
      meta: [
        {
          name: "keywords",
          content: this.SystemOption.seoKeyWord,
        },
        {
          name: "description",
          content: this.SystemOption.seoDescribe,
        },
      ],
    };
  },
  data() {
    return {
      select: 1,
      form: {
        //联系我们表单
        username: "",
        phone: "",
        address: "",
        advisoryType: "",
        problemDes: "",
        code: "",
      },
      isSendCode: "发送验证码",
      SystemOption: [], //SEO 配置
      isShowWXrcode: false, //是否悬浮显示微信二维码
      isDisFloat: false,
      disabled: false,
      provinceId: "",
      cityId: "",
      provinceList: [],
      cityList: [],
    };
  },

  methods: {
    loadSeo() {
      //获取SEO配置
      this.axios
        .get(this.Url.apiUrl + "SystemOption/GetSystemOption")
        .then((res) => (this.SystemOption = res.data));
    },

    //获取随机 guid
    getGuid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    //获取验证码
    GetCode(phone) {
      let that = this;
      let guid = that.getGuid();
      that.guid = guid;
      if (this.form.phone == "") {
        alert("请填写手机号");
        return false;
      } else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(phone)) {
        alert("请填写正确的手机号");
        return false;
      }
      this.isSendCode = "已发送";
      this.axios({
        type: "post",
        url: this.Url.apiUrl + "sms/code/" + that.guid + "",
        params: {
          phone: phone,
        },
      }).then(() => {});
    },
    //提交表单
    onSubmit() {
      let that = this;
      if (this.form.username == "") {
        alert("请输入您的姓名");
        return false;
      }
      if (this.form.advisoryType == "") {
        alert("请选择咨询类别");
        return false;
      }
      if (this.form.phone == "") {
        alert("请填写您的手机号");
        return false;
      }
      if (this.form.code == "") {
        alert("请输入您收到的验证码");
        return false;
      }
      if (this.form.problemDes == "") {
        alert("请输入问题概述");
        return false;
      }
      if (this.form.address == "") {
        alert("请选择您的地理位置");
        return false;
      }
      this.disabled = true;
      //验证输入的验证码是否正确
      if (that.guid == undefined) {
        alert("发送失败,请重新输入您的咨询信息");
        return false;
      }
      that
        .axios({
          type: "post",
          url: this.Url.apiUrl + "v/code/" + that.guid + "",
          params: {
            phone: that.form.phone,
            code: that.form.code,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            alert("验证码不正确,请重新输入");
            return false;
          } else {
            //提交表单
            that
              .axios({
                method: "post",
                url: this.Url.apiUrl + "SystemOption/CaseAdvisory",
                data: that.form,
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then(() => {
                alert("提交成功");
                that.disabled = true;
              });
          }
        });
    },
    //获得地区
    getRegions(pId) {
      this.axios({
        type: "post",
        url: this.Url.apiUrl + "SystemOption/GetRegion",
        params: {
          parentRegionId: pId,
        },
      }).then((res) => {
        if (pId > 0) {
          this.cityList = res.data;
        } else {
          this.provinceList = res.data;
        }
      });
    },
    //选择省份
    selectProvince() {
      this.cityId = "";
      this.form.address = "";
      this.getRegions(this.provinceId);
    },
    //选择市区
    selectCity() {
      let provinceAddress = this.provinceList.find(
        (val) => val.regionId == this.provinceId
      ).regionName;

      let cityAddress = this.cityList.find(
        (val) => val.regionId == this.cityId
      ).regionName;

      this.form.address = provinceAddress + cityAddress;

      console.log(this.form.address);
    },
  },
  created() {

    //初始化路径数据
    this.$store.state.Currentposition = [
      {
        path: "/",
        name: "首页",
      },
      {
        path: "/contact.html",
        name: "联系我们",
      },
    ];
    this.loadSeo();
    this.getRegions(0);
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  display: block;
  width: 1200px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 26px 21px;
    overflow: hidden;
  }

  .Item-from {
    width: 100%;
    height: 320px;
    background-color: #ffffff;
    box-shadow: 0px 1px 10px 0px rgba(222, 222, 222, 0.3);
    border-radius: 5px;
    margin: 20px 0;

    // border: solid 1px #bd9d6c;
    @media screen and(max-width: 768px) {
      margin: 0;
      box-shadow: none;
      height: auto;
    }

    .Item-flex {
      display: flex;

      @media screen and(max-width: 768px) {
        display: block;
      }

      .el-form-item {
        width: 380px;
        margin: 15px auto;

        @media screen and(max-width: 768px) {
          width: 100%;
        }

        .submit {
          background: #bd9d6c;
          border-radius: 2px;
          border: 1px solid #bd9d6c;

          @media screen and (max-width: 768px) {
            margin: 0 auto;
            display: block;
          }
        }
      }
    }
  }

  .map {
    position: relative;
    display: block;
    margin: 20px 0;
    width: 100%;
    overflow: hidden;
    height: 350px;

    @media screen and (max-width: 768px) {
      margin: 40px 0;
    }

    img {
      width: 1200px;
      height: auto;

      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }
}
.Icon_group {
  position: fixed;
  right: 100px;
  height: 240px;
  top: 50%;
  z-index: 99999;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media screen and (max-width: 1300px) {
    height: 163px;
  }
  @media screen and (max-width: 768px) {
    right: 33px;
  }
  .Icon_item {
    width: 60px;
    height: 60px;
    cursor: pointer;
    @media screen and (max-width: 1300px) {
      height: 40px;
      width: 40px;
    }
    img {
      width: 100%;
    }
  }
}
</style>
